import { ITraveller } from '../booking/ITraveller';
import {IAgent, IAgentResult} from '../booking/IAgent';

import { ICurrency, ICurrencyWithPrice } from './ICurrency';
import { IMealplan } from "libraries/hotel/models/details";
import { IPenalty } from '../../hotel/IResourceHotel';
import { IBookingRooms } from 'libraries/hotel/models/booking';
import { IGetBookingsCommonResponse } from '../../booking/interfaces/IGetBookings';
import { IQuoteSupplement } from "libraries/hotel/models/quote";

export interface IBooking {
    type: string;
    code: string;
    xType: string;
    xStatus: string;
    dateCreated: string;
    whenCreated: string;
    owner: IAgent;
    dateLastUpdated: string;
    remark?: {
        text: string;
    };
    externalBooking?: IExternalBooking;
    syscode: string;
    host: string;
    end: string;
    begin: string;
    topic: string;
    traveller: {
        [id: string]: ITraveller;
    };
    agent: IAgentResult;
}


/**
 * @deprecated use IGetBookingsCommonResponse instead
 */
export interface IBookingResult extends IGetBookingsCommonResponse {
}

interface IServiceInfo {
    code: string;
    title: string;
}

export interface IRoom {
    xId: string;
    syscode: string;
    code: string;
    xCode: string;
    xStatus: string;
    name: {
        text: string;
        language: string;
    };
    traveller: string;
    property: string;
    begin: string;
    end: string;
    duration: IDuration;
    penalty: IPenalty;
}

interface IProperty {
    xId: string;
    syscode: string;
    xStatus: string;
    name: string;
    product: string;
    segment: string;
    room: string;
}

interface ISegment extends IProduct {
    product: string;
    property: string;
    room: string;
}

interface IProduct {
    xId: string;
    xType: string;
    name: string;
    begin: string;
    end: string;
    duration: IDuration;
    segment: string;
    property: string;
    room: string;
    host: string;
}

interface IDuration {
    day: string;
    night: string;
}


export interface ICreateBooking extends IBooking {
    duration: IDuration;
    product: { [key: string]: IProduct };
    segment: { [key: string]: ISegment };
    property: { [key: string]: IProperty };
    room: IBookingRooms;
    dateLastCancellationWithoutPenalty: string;
    price: IPrice;
    salesInformation?: ISalesInformation | ISalesInformation[];
    externalBooking: IExternalBooking;
    mealplan?: { [key: string]: IMealplan };
}

export interface ICreateBookingResult {
    key: 'string';
    transactionId: 'string';
    status: { severity: string };
    booking: ICreateBooking;
}

export enum PriceDetailType {
    ResortFee = "resortFee",
    Accomodation = "accomodation",
    MealPlan = "mealplan",
}

export interface IPrice {
    currency: { [key: string]: ICurrency };
    total: {
        cost: ICurrencyWithPrice;
    };
    detail: IDetail | IResortFeeDetail | Array<IDetail | IResortFeeDetail>;
}

export interface ICost {
    [key: string]: number;
}

export interface IRetail {
    [key: string]: number;
}

export interface IByRoom {
    room?: string;
}

export interface IDetail extends IByRoom {
    xType?: PriceDetailType;
    quantity: number;
    value: IValueOrTotal;
    total: IValueOrTotal;
    traveller?: string | string[];
    segment?: string;
    room?: string;
    included: boolean;
}

export interface IResortFeeDetail extends IQuoteSupplement {
    xType?: PriceDetailType.ResortFee;
    code: string;
    name: string;
    details?: IQuoteSupplement;

}

export interface ISalesInformation extends IByRoom {
    text: string;
    segment: string;
    mealplan: string;
    traveller: string | string[];
}

export interface IValueOrTotal {
    cost: ICost;
}

export interface IExternalBooking {
    code: string;
    type: string;
    host: string;
}

/**
 * Values are lower-cased like all values used in search QueryString.
 */
export enum OperationStatus {
    success = "success",
    warning = "warning",
    error = "error",
}

export enum TypeStatus {
    air = "air",
    stay = "stay",
    vehicleRental = "vehiclerental",
}
